var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container", staticClass: "vks-ge-plot" },
    [
      _c("canvas", {
        ref: "canvas",
        staticClass: "vks-ge-plot-canvas",
        class: { "is-dot-hover": _vm.dotHover },
        on: {
          mousemove: _vm.onMouseMove,
          mouseout: _vm.onMouseOut,
          click: _vm.onClick,
        },
      }),
      _c("VariantSifterGeTissueDotMenu", {
        attrs: {
          open: _vm.dotMenuOpen,
          tissue: _vm.dotMenuTissue,
          annotation: _vm.dotMenuAnnotation,
          "is-selected": _vm.dotMenuIsSelected,
          "anchor-x": _vm.dotMenuX,
          "anchor-y": _vm.dotMenuY,
        },
        on: { "toggle-select": _vm.onDotMenuToggleSelect },
      }),
      _vm.actionBubble
        ? _c(
            "div",
            {
              staticClass: "vks-ge-action-bubble",
              attrs: { role: "status", "aria-live": "polite" },
            },
            [_vm._v(" " + _vm._s(_vm.actionBubble) + " ")]
          )
        : _vm._e(),
      _c("div", { ref: "tooltip", staticClass: "vks-ge-plot-tooltip hidden" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }